var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c("el-input", {
        attrs: {
          value: _vm.value,
          placeholder: _vm.disabled
            ? ""
            : _vm.$t("SeaExport.DoubleClickToAddOperationRequirements"),
          type: "textarea",
          rows: 4
        },
        nativeOn: {
          dblclick: function($event) {
            return _vm.onDblclick($event)
          }
        }
      }),
      _vm.selectOperationReqDialog.visible
        ? _c("select-operation-req-dialog", {
            attrs: {
              visible: _vm.selectOperationReqDialog.visible,
              lob: "AE",
              value: _vm.selectOperationReqDialog.value
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.selectOperationReqDialog, "visible", $event)
              },
              callback: _vm.onInput
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }